import { Tag } from "antd";

// Renders an orange "Draft" tag for unpublished roadmap content; nothing when published.
// Glanceable status used in the stages rail + requirements accordion.
function DraftTag({ published }: { readonly published: boolean }) {
  if (published) return null;
  return (
    <Tag className="m-0" color="orange">
      Draft
    </Tag>
  );
}

export default DraftTag;
